<ng-container *appLoad="let tasks of load$">
  <div class="row">
    <div class="col tasks">
      <!-- header -->
      <div class="tasks__header">
        <div class="row">
          <!-- filter / status -->
          <div class="col align-self-center">
            <lds-choice-group
              identifier="taskStatus"
              name="taskStatus"
              [options]="taskStatusOptions"
              [selected]="selectedTaskStatus"
              (getChange)="onChoiceChange($event)">
            </lds-choice-group>
          </div>

          <!-- btns -->
          <div class="col-auto">
            <lds-button appearance="secondary" (click)="addTask()">
              Add Task
            </lds-button>
          </div>
        </div>
      </div>

      <!-- list of tasks -->
      <div class="tasks__list">
        <ng-container *ngIf="tasks.length; else tplNoResults">
          <ng-container *ngFor="let task of tasks">
            <!-- TODO: split out into own component [future release] -->

            <div class="task">
              <spark-summary-card>
                <!-- task / status -->
                <summary-card-icon>
                  <span
                    class="task__status task__status--{{
                      task.due | taskTrackingStatus
                    }}">
                    <lds-icon
                      name="circle"
                      size="xs"
                      variation="solid"
                      appearance="inherit">
                    </lds-icon>
                  </span>
                </summary-card-icon>

                <!-- task / details -->
                <summary-card-header>
                  <div class="row">
                    <div class="col-12 col-sm-4">
                      <div class="summary-card__title task__title-truncate">
                        {{ task.title }}
                      </div>
                      <div class="task__notes-truncate">
                        {{ task.notes }}
                      </div>
                    </div>
                    <div class="col-12 col-sm-4">
                      <app-tag-input
                        [entityId]="entityId"
                        [entityType]="tagEntityType"
                        [taskId]="task.id"
                        [initialTags]="task.tags"
                        [showLabel]="false"
                        [showEmptyState]="false"
                        [readonly]="true">
                      </app-tag-input>
                    </div>
                    <div class="col-6 col-sm">
                      <div>
                        <lds-icon
                          name="calendar"
                          size="xs"
                          appearance="inherit">
                        </lds-icon>
                        <span class="ml-xs">
                          {{ task.due | taskDueDate | date : 'dd/MM/yyyy' }}
                        </span>
                      </div>
                    </div>

                    <!-- task / priority -->
                    <ng-container
                      *ngIf="task.priority | taskHasAssignedPriority">
                      <div class="col-6 col-sm-2">
                        <div>
                          <lds-icon name="flag" size="xs" appearance="inherit">
                          </lds-icon>
                          <span class="ml-xs">
                            {{ task.priority | taskUrgency }}
                          </span>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </summary-card-header>

                <summary-card-actions>
                  <app-context-menu
                    summary-card-action
                    [menuItems]="task.id | taskContextMenu:this">
                  </app-context-menu>
                </summary-card-actions>
              </spark-summary-card>
            </div>
          </ng-container>
        </ng-container>

        <!-- TODO: add empty status/messaging [future release] -->
        <!-- template / no results -->
        <ng-template #tplNoResults></ng-template>
      </div>
    </div>
  </div>
</ng-container>
